import { IUpsell, IRefusalUpsell } from '@/interfaces/Upsell';

class RefusalUpsell implements IRefusalUpsell {
  id: number;
  order: number;
  refusal_upsell_data: IUpsell;

  constructor(refusalUpsell: any) {
    this.id = refusalUpsell.refusal_upsell;
    this.order = refusalUpsell.order;
    this.refusal_upsell_data = refusalUpsell.refusal_upsell_data;
  }
}

export default RefusalUpsell;